import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import ThemeApi from '../server/ThemeApi';


function createSuccessHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}


export default {

    getAll: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.THEME_LIST);
        const handleError = createErrorHandler(ActionTypes.THEME_LIST_ERROR);

        return ThemeApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

};
